import { Component, Input, OnChanges } from '@angular/core';
import { MapModalComponent } from './map-modal/map-modal.component';
import { GeocodingDataService } from '../../../../services/geocoding-data.service';
import { TcmModalService } from '../../services/tcm-modal.service';

@Component({
    selector: 'map-viewer',
    templateUrl: './map-viewer.component.html',
    styleUrls: ['./map-viewer.component.scss'],
    standalone: false
})
export class MapViewerComponent implements OnChanges {
    private location: google.maps.LatLng;

    @Input() public addressComponents: string[];
    public canOpen: boolean;
    public isLoading: boolean;

    public constructor(private modalService: TcmModalService, private geocodingDataService: GeocodingDataService) {
    }

    public openMap() {
        this.modalService.openComponentInModal(MapModalComponent, "md", { location: this.location })
    }

    private async setLocationAsync() {
        this.location = await this.geocodingDataService.getAddressLocationAsync(this.addressComponents.join(" "));
    }

    public async ngOnChanges() {        
        this.canOpen = false;

        // if (!this.addressComponents || this.addressComponents.filter(i => i && i.trim()).length < 2) {
        //     this.canOpen = false;

        //     return;
        // }

        // this.isLoading = true;
        
        // try {
        //     await this.setLocationAsync();
        //     this.canOpen = true;
        // }
        // catch {
        //     this.canOpen = false;
        // }
        // finally {
        //     this.isLoading = false;
        // }
    }
}
